module.exports = __webpack_public_path__ + "img/step-2.dcc6f575.jpg";